import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE, extractFilenameFromHeaders } from '@skylab-shared/utils';
import { AxiosResponse } from 'axios';
import { ExportQueryParameters } from '../../common/export/export-query.parameters';
import { ExportResult } from '../../common/export/export-query.result';
import { ExportQuery } from '../../common/export/export.query-base';

export interface PurchasesByPeriodExportParameters extends ExportQueryParameters { }

export class PurchasesByPeriodExportQuery extends ExportQuery<ExportResult> {
    public constructor(parameters: PurchasesByPeriodExportParameters) {
        super(parameters);
    }
}

export class PurchasesByPeriodExportQueryHandlerBase implements QueryHandler<PurchasesByPeriodExportQuery, ExportResult> {
    private static Url = TaggedUrl.join('purchaseByPeriod/export', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ parameters }: PurchasesByPeriodExportQuery): Promise<ExportResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns
            }
        };

        const response = await this.http.post<Blob>(PurchasesByPeriodExportQueryHandlerBase.Url, requestData, { responseType: 'blob', timeout: 3 * MS_PER_MINUTE });
        return {
            file: response.data,
            filename: extractFilenameFromHeaders(<AxiosResponse>response) ?? ''
        };
    }
}
